'use strict';

/**
 * Component for assets
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var DetailModalView = require('../../layout/detail-modal');

var template = require('../../../templates/components/detail/field-assets.hbs');

var AssetsComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'slider': '.image-slider',
        'sliderImages': '.image-slider img',
        'sliderOuter': '.image-slider-outer',
        'sliderPager': '.image-slider-pager',
        'images': '.image',
        'imagesTags': '.image img',
        'slideToImage': '[data-action="slide-image"]',
        'video': 'video',
        'videoPlayButton': '[data-action="play-video"]',
        'click @ui.videoPlayButton': 'playVideo',
    },

    events: {
        'click @ui.slider': 'sliderClicked',
        'click @ui.slideToImage': 'slideToImage',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },
    },

    onRender: function() {
        this.initSlider();

        this.ui.imagesTags.on('load error', function(event) {
            if (event) {
                $(event.currentTarget).closest('.image').removeClass('loading');
            }
        }).each(function() {
            // if images are from the cache, the load-event will not be triggered. so we do it on our own
            if (this.complete) {
                $(this).trigger('load');
            }
        });

        // Bind video events
        this.ui.video.on('play', this.onPlayVideo.bind(this));
        this.ui.video.on('pause stop', this.onStopVideo.bind(this));
    },

    initSlider: function() {
        if (this.ui.sliderImages.length > 1) {
            this.ui.slider.slick({
                infinite: false,
                speed: 500,
                variableWidth: true,
                touchThreshold: 10,
                arrows: true,
                nextArrow: this.$('.slide-next'),
                prevArrow: this.$('.slide-prev'),
            });

            this.ui.slider.on('mousedown', function(event) {
                this.ui.slider.find('.slick-track').addClass('slick-dragged');
            }.bind(this));

            this.ui.slider.on('mouseup', function(event) {
                this.ui.slider.find('.slick-track').removeClass('slick-dragged');
            }.bind(this));

            this.ui.slider.on('afterChange', function(event, slick, currentSlide) {
                this.ui.sliderPager.find('li').removeClass('is-active');
                this.ui.sliderPager.find('li[data-idx="' + currentSlide + '"]').addClass('is-active');
            }.bind(this));
        } else {
            this.ui.slider.slick = null;
        }
    },

    /**
     * Destroys the attached slider
     */
    destroySlider: function() {
        if (_.isObject(this.ui.slider)
            && this.ui.slider.length > 0
            && this.ui.slider.slick
        ) {
            this.ui.slider.slick('unslick');
            this.ui.slider.off();
        }
    },

    /**
     * Next/Prev slide on click
     */
    sliderClicked: function(event) {
        App.addModal(new DetailModalView({
            model: this.model,
            slyPage: this.ui.slider.slick ? this.ui.slider.slick('slickCurrentSlide') : 0,
        }), {additionalClassName: 'modal-lightbox'});
    },

    /**
     * Slides to an image, when thumbnail is clicked
     * @param {object} event The click event
     */
    slideToImage: function(event) {
        var li = $(event.currentTarget);
        var index = li.data('idx');

        if (this.ui.slider.slick) {
            this.ui.slider.slick('slickGoTo', index);
            li.addClass('is-active').siblings().removeClass('is-active');
        }
    },

    onBeforeDestroy: function() {
        this.destroySlider();
        this.ui.video.off();
    },

    onPlayVideo: function(event) {
        $(event.currentTarget).addClass('is-playing');
    },

    onStopVideo: function(event) {
        $(event.currentTarget).removeClass('is-playing');
    },

    playVideo: function(event) {
        event.stopPropagation();
        var curTarget = $(event.currentTarget);
        var video = curTarget.prev();

        if (video.is('video')) {
            video[0].play();
        }
    },

    hasValue: function() {
        var field = this.getOption('field');
        var images = this.model.get(field.name);

        return images.length ? true : false;
    },
});

module.exports = AssetsComponent;